module.exports = __webpack_public_path__ + "static/media/icon-link.49dc502b.svg";